<template>
  <div>
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-set-surgery-price"
      ok-only
      centered
      size="lg"
      :title="$t('surgery.set-surgery-price')"
    >
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitSetSurgeryPrice()"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
      <b-card-text>
        <h3 class="text-center mb-1">{{ $t("surgery.surgery2") }}</h3>
        <div class="p-1 mb-3 border rounded shadow-sm surgery-price-bg">
          <b-row class="align-items-center">
            <b-col md="4" class="text-center">
              <h6 class="mb-0">
                <strong>{{ $t("surgery.surgery2") }}:</strong>
                {{ selectedSurgery && selectedSurgery.surgery && selectedSurgery.surgery.title }}
              </h6>
            </b-col>
            <b-col md="5" class="text-center">
              <b-form-group
                :label="$t('reception.Surgery Price')"
                label-for="surgeryPriceID"
              >
                <b-form-input
                  id="surgeryPriceID"
                  v-model="surgeryPrice.price"
                  type="number"
                  :placeholder="$t('reception.Surgery Price')"
                  class="form-control-lg"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" class="text-center">
              <b-form-group
                :label="$t('reception.Surgery Discount')"
                label-for="surgeryDiscountID"
              >
                <b-form-input
                  id="surgeryDiscountID"
                  v-model="surgeryPrice.surgery_discount"
                  type="number"
                  :placeholder="$t('reception.Surgery Discount')"
                  class="form-control-lg"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <hr class="divider my-3" />
        <h3 class="text-center mb-1">{{ $t("surgery.surgery-doctor") }}</h3>
        <b-row>
          <b-col lg="12" class="mb-2">
            <div class="p-2 border rounded shadow-sm bg-light">
              <b-row class="align-items-center">
                <b-col md="8">
                  <b-form-group
                    :label="$t('surgery.split-amount-equally')"
                    label-for="splitAmountID"
                  >
                    <b-form-input
                      id="splitAmountID"
                      v-model.number="splitAmount"
                      type="number"
                      :placeholder="$t('surgery.enter-amount-to-split')"
                      class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4" class="d-flex align-items-end">
                  <b-button
                    variant="primary"
                    @click="splitAmountBetweenDoctors"
                    class="btn-block"
                  >
                    {{ $t("surgery.split-amount") }}
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col lg="12">
            <div
              v-for="(doctor, i) in surgeryPrice.doctors"
              :key="doctor.id"
              class="p-1 mb-3 border rounded shadow-sm doctor-bg"
            >
              <b-row class="align-items-center">
                <b-col md="3" class="text-center">
                  <h6 class="mb-0">
                    <strong>{{ $t("surgery.Doctor") }}:</strong>
                    {{ doctor.name }} <br>
                    <span v-if="doctor.type === 'surgeon'" class="text-green">
                      ({{ $t("surgery.surgeon-doctor") }})</span
                    >
                    <span v-if="doctor.type === 'anesthetist'" class="text-green">
                      ({{ $t("surgery.anesthesia-doctor") }})</span
                    >
                  </h6>
                </b-col>
                <b-col md="5">
                  <b-form-group
                    :label="$t('reception.Doctor Price')"
                    label-for="doctorPriceID"
                  >
                    <b-form-input
                      id="doctorPriceID"
                      v-model.number="doctor.doctor_price"
                      type="number"
                      :placeholder="$t('reception.Doctor Price')"
                      class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    :label="$t('reception.Doctor Discount')"
                    label-for="doctorDiscountID"
                  >
                    <b-form-input
                      id="doctorDiscountID"
                      v-model.number="doctor.doctor_discount"
                      type="number"
                      :placeholder="$t('reception.Doctor Discount')"
                      class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <hr class="divider my-3" />
        <h3 class="text-center mb-1">{{ $t("surgery.doctor-assistants") }}</h3>
        <b-row>
          <b-col lg="12">
            <div
              v-for="(doctor_assistant, index) in surgeryPrice.doctor_assist"
              :key="doctor_assistant.id"
              class="p-1 mb-3 border rounded shadow-sm consultancy-bg"
            >
              <b-row class="align-items-center">
                <b-col md="5" class="text-center">
                  <h6 class="mb-0 text-primary">
                    <strong>{{ $t("surgery.doctor-assistants") }}:</strong>
                    {{ doctor_assistant.name }} <br />
                    <span v-if="doctor_assistant.type === 'surgeon_assistant'" class="text-green">
                      ({{ $t("surgery.surgeon-assistant") }})</span
                    >
                    <span v-if="doctor_assistant.type === 'anesthetist_assistant'" class="text-green">
                      ({{ $t("surgery.anesthesia-assistant") }})</span
                    >
                  </h6>
                </b-col>
                <b-col md="7">
                  <b-form-group
                    :label="$t('surgery.doctor-assistant-price')"
                    :label-for="`doctorAssistantPrice-${index}`"
                  >
                    <b-form-input
                      :id="`doctorAssistantPrice-${index}`"
                      v-model.number="doctor_assistant.doctor_assistant_price"
                      type="number"
                      class="form-control-lg"
                      :placeholder="$t('surgery.doctor-assistant-price')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <hr class="divider my-3" />
        <h3 class="text-center mb-1">{{ $t("surgery.consultancy-doctor") }}</h3>
        <b-row>
          <b-col lg="12">
            <div
              v-for="(consultancy, index) in surgeryPrice.doctors_consultancies"
              :key="consultancy.id"
              class="p-1 mb-3 border rounded shadow-sm consultancy-bg"
            >
              <b-row class="align-items-center">
                <b-col md="5" class="text-center">
                  <h6 class="mb-0 text-primary">
                    <strong>{{ $t("surgery.consultancy-doctor") }}:</strong>
                    {{ consultancy.name }}
                  </h6>
                </b-col>
                <b-col md="7">
                  <b-form-group
                    :label="$t('surgery.Doctor-consultancy-price')"
                    :label-for="`consultancyPrice-${index}`"
                  >
                    <b-form-input
                      :id="`consultancyPrice-${index}`"
                      v-model.number="consultancy.doctor_price"
                      type="number"
                      class="form-control-lg"
                      :placeholder="$t('surgery.Doctor-consultancy-price')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-modal
      :no-close-on-backdrop="true"
      :id="`modal-pay-doctor`"
      :title="$t('surgery.pay-doctor')"
      ok-only
      centered
      size="lg"
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorPrice()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="12">
            <b-row
              v-for="(item, i) in payDoctorDataPost.doctors"
              :key="item.id"
            >
              <b-col lg="6" class="px-2 d-flex align-items-center">
                <h3>
                  {{ $t("surgery.pay-doctor") }} :
                  {{ payDoctorDataPost.doctors[i].name }}
                </h3>
              </b-col>
              <b-col lg="6">
                <b-form-checkbox
                  :id="item.doctor_id"
                  v-model="payDoctorDataPost.doctors[i].isSelected"
                  name="checkbox-1"
                >
                  {{ $t("surgery.pay for this doctor") }}
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('surgery.surgery')">
      <!-- Search Patient Name -->
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <!-- <h2>{{ $t("surgery.surgery-patient-history") }}</h2> -->
            <div class="d-flex justify-content-end mb-2">
              <!-- Audit Log Button for all patient-surgeries -->
              <AuditLogDrawer
                :model-type="`App\\Models\\Surgery`"
              />
            </div>
            <br />
          </b-col>
          <b-col md="3" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="surgeryName"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" cols="12">
            <AutoComplete
              :label="$t('surgery.surgery')"
              v-model="surgery_id"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="surgery"
              text-title="title"
            />
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group :label="$t('common.date')" label-for="surgery_date">
              <datepicker
                id="surgery_date"
                v-model="surgery_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col md="2" cols="12">
            <b-form-group :label="$t('common.price')" label-for="Price">
              <b-form-input
                id="Price"
                type="number"
                v-model="surgeyPrice"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="2"
            cols="4"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getSurgeryList()">
              {{ $t("common.search") }}
            </b-button>
          </b-col>
        </b-row>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(surgery_date_time)="data">
            <span
              style="unicode-bidi: isolate"
              :style="{
                direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
              }"
              >{{ data.item.surgery_date_time }}</span
            >
          </template>
          <!-- has_sub_surgery -->
          <template #cell(title)="data">
            <div class="text-nowrap font-weight-bold" style="color: black">
              {{ data.item.patient_card && data.item.patient_card.patient && data.item.patient_card.patient.name }}
              <span class="text-primary"> ({{ data.item.surgery && data.item.surgery.title }})</span>
            </div>
          </template>
          <template #cell(has_sub_surgery)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.sub_surgeries && data.item.sub_surgeries.length"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template>
          <template #cell(is_sub_surgery)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.parent_id"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template>
          <template #cell(money_collected)="data">
            <div class="text-nowrap">
              <span
                style="font-weight: bold; color: green"
                v-if="data.item.money_collected === 1"
                >{{ $t("common.yes") }}</span
              >
              <span v-else style="font-weight: bold; color: red">
                {{ $t("common.no") }}</span
              >
            </div>
          </template>
          <template #cell(type)="data">
            <div class="text-nowrap"></div>
          </template>
          <template #cell(surgery_doctor)="data">
            <div class="doctor-prices text-nowrap">
              <div
                v-for="item in formatDoctorPrices(data.item.doctors_prices)"
                :key="item.id"
                class="doctor-price-item"
              >
                <div class="doctor-name">{{ item.name }}</div>
                <div class="price-details mx-1">
                  /
                  <span class="price">{{ formatIQD(item.doctor_price) }}</span>
                  <span class="discount" v-if="item.doctor_discount > 0">
                    (-{{ formatIQD(item.doctor_discount) }})
                  </span>
                  /
                  <span
                    class="status-badge"
                    :class="{
                      'status-paid': item.payment_status === 1,
                      'status-pending': item.payment_status === 0,
                    }"
                  >
                    {{ item.payment_status === 1 ? "Paid" : "Pending" }}
                  </span>
                </div>
              </div>
              <div class="mt-1">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="openEditDoctorSurgeryModal(data.item)"
                  block
                  :disabled="loadingOpenEditDoctorSurgeryModal"
                >
                  <span v-if="!loadingOpenEditDoctorSurgeryModal">{{
                    $t("accounting.edit-doctor-surgery")
                  }}</span>
                  <b-spinner small v-else></b-spinner>
                </b-button>
              </div>
              <div class="total-price mt-2">
                <strong>{{ $t("accounting.total_price") }}: </strong>
                <span class="">{{
                  formatIQD(data.item.doctors_prices && data.item.doctors_prices.total_price)
                }}</span>
              </div>
            </div>
          </template>
          <template #cell(doctors_assistants_prices)="data">
            <div class="doctor-prices text-nowrap">
              <div
                v-for="item in formatDoctorAssistantsPrices(
                  data.item.doctors_assistants_prices
                )"
                :key="item.id"
                class="doctor-price-item"
              >
                <div class="doctor-name">{{ item.name }}</div>
                <div class="price-details mx-1">
                  /
                  <span class="price">{{
                    formatIQD(item.doctor_assistant_price)
                  }}</span>
                  /
                  <span
                    class="status-badge"
                    :class="{
                      'status-paid': item.payment_status === 1,
                      'status-pending': item.payment_status === 0,
                    }"
                  >
                    {{ item.payment_status === 1 ? "Paid" : "Pending" }}
                  </span>
                </div>
              </div>
              <div class="mt-1">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="openEditDoctorAssistantsModal(data.item)"
                  block
                  :disabled="loadingOpenEditDoctorAssistantsModal"
                >
                  <span v-if="!loadingOpenEditDoctorAssistantsModal">{{
                    $t("accounting.edit-doctor-assistants")
                  }}</span>
                  <b-spinner small v-else></b-spinner>
                </b-button>
              </div>
              <div class="total-price mt-2">
                <strong>{{ $t("accounting.total_price") }}: </strong>
                <span class="">{{
                  formatIQD(data.item.doctors_assistants_prices && data.item.doctors_assistants_prices.total_price)
                }}</span>
              </div>
            </div>
          </template>
          <template #cell(consultancy_doctors)="data">
            <div class="doctor-prices text-nowrap">
              <div
                v-for="item in formatDoctorPrices(
                  data.item.doctors_consultancies_prices
                )"
                :key="item.id"
                class="doctor-price-item"
              >
                <div class="doctor-name">{{ item.name }}</div>
                <div class="price-details mx-1">
                  /
                  <span class="price">{{ formatIQD(item.doctor_price) }}</span>
                  /
                  <span
                    class="status-badge"
                    :class="{
                      'status-paid': item.payment_status === 1,
                      'status-pending': item.payment_status === 0,
                    }"
                  >
                    {{ item.payment_status === 1 ? "Paid" : "Pending" }}
                  </span>
                </div>
              </div>
              <div class="mt-1">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="openAddConsultancyModal(data.item)"
                  block
                  :disabled="loadingOpenEditDoctorConsultancyModal"
                >
                  <span v-if="!loadingOpenEditDoctorConsultancyModal">{{
                    $t("surgery.add-doctor-consultancy")
                  }}</span>
                  <b-spinner small v-else></b-spinner>
                </b-button>
              </div>
              <div class="total-price mt-2">
                <strong>{{ $t("accounting.total_price") }}: </strong>
                <span class="">{{
                  formatIQD(data.item.doctors_consultancies_prices && data.item.doctors_consultancies_prices.total_price)
                }}</span>
              </div>
            </div>
          </template>
          <template #cell(price)="data">
            <div class="text-nowrap price-cell-alt">
              <div class="price-icon">💵</div>
              <div class="price-content">
                <div class="price-title">{{ $t("common.price") }}</div>
                <div class="price-amount">{{ formatIQD(data.item.price) }}</div>
              </div>
            </div>
          </template>
          <template #cell(total_discount)="data">
            <div class="text-nowrap discount-cell-alt">
              <div class="discount-icon">🎁</div>
              <div class="discount-content">
                <div class="discount-title">
                  {{ $t("surgery.total_discount") }}
                </div>
                <div class="discount-amount">
                  {{ formatIQD(data.item.total_discount) }}
                </div>
              </div>
            </div>
          </template>
          <template #cell(total_price_after_discount)="data">
            <div class="text-nowrap final-price-cell-alt">
              <div class="final-price-icon">💳</div>
              <div class="final-price-content">
                <div class="final-price-title">
                  {{ $t("surgery.total_price_after_discount") }}
                </div>
                <div class="final-price-amount">
                  {{ formatIQD(data.item.total_price_after_discount) }}
                </div>
              </div>
            </div>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                v-if="data.item.price == 0"
                size="sm"
                pill
                variant="outline-success"
                class="mb-75 mx-1"
                @click="show(data.item)"
              >
                {{ $t("surgery.set-surgery-price") }}
              </b-button>
              <b-button
                v-else
                size="sm"
                pill
                variant="outline-warning"
                class="mb-75 mx-1"
                @click="show(data.item)"
              >
                {{ $t("surgery.update-surgery-price") }}
              </b-button>
              <!-- Audit Log Button for each patient-surgery -->
              <div class="d-inline-block mb-75 mx-1">
                <PatientSurgeryAuditLog :item="data.item" />
              </div>
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getSurgeryList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <b-modal
      id="modal-add-consultancy"
      :title="$t('surgery.add-doctor-consultancy')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-row>
        <b-col md="12" cols="12" class="mt-3">
          <b-form-group label="Doctors">
            <v-select
              v-model="consultancy_doctors"
              :options="doctors"
              multiple
              label="name"
              :reduce="(doctor) => doctor"
              :close-on-select="false"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="addConsultancy"
          class="m-0"
          :disabled="loadingEditDoctorConsultancy"
          ref="button"
          block
        >
          <span v-if="!loadingEditDoctorConsultancy">{{
            $t("common.save")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-edit-doctor-surgery"
      :title="$t('accounting.edit-doctor-surgery')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col md="12" cols="12" class="mt-3">
            <b-form-group label="Doctors">
              <v-select
                v-model="selectedDoctors"
                :options="doctors"
                multiple
                label="name"
                :reduce="(doctor) => doctor"
                :close-on-select="false"
              >
                <template #option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span v-if="type == 'surgeon'" class="text-primary">
                      ({{ $t("hospital.surgeon") }})
                    </span>
                    <span v-if="type == 'anesthetist'" class="text-primary">
                      ({{ $t("hospital.anesthetist") }})
                    </span>
                  </b>
                </template>
                <template #selected-option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span v-if="type == 'surgeon'" class="text-success">
                      ({{ $t("hospital.surgeon") }})
                    </span>
                    <span v-if="type == 'anesthetist'" class="text-success">
                      ({{ $t("hospital.anesthetist") }})
                    </span>
                  </b>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- <b-col md="12" cols="12" class="mb-2">
            <div
              v-if="selectedDoctors.length > 0"
              class="d-flex justify-content-center flex-wrap"
            >
              <div
                v-for="doctor in selectedDoctors"
                :key="doctor.id"
                class="doctor-card"
              >
                <p class="mb-0">
                  {{ doctor.name }}
                </p>
                <div class="role-selection">
                  <b-form-checkbox
                    v-model="doctor.type"
                    :value="'surgeon'"
                    :unchecked-value="'anesthetist'"
                    class="role-checkbox"
                    switch
                    default-value="surgeon"
                  >
                    {{ doctor.type }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitEditDoctorSurgery"
          class="m-0"
          :disabled="loadingEditDoctorSurgery"
          block
        >
          <span v-if="!loadingEditDoctorSurgery">
            {{ $t("common.save") }}
          </span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-edit-doctor-assistants"
      :title="$t('accounting.edit-doctor-assistants')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col md="12" cols="12" class="mt-3">
            <b-form-group label="Doctors">
              <v-select
                v-model="selectedDoctorAssistants"
                :options="doctorAssistants"
                multiple
                :close-on-select="false"
              >
                <template #option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-primary">
                      ({{
                        type == "surgeon_assistant"
                          ? $t("hospital.surgeon-assistant")
                          : $t("hospital.anesthetist-assistant")
                      }})
                    </span>
                  </b>
                </template>
                <template #selected-option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-success">
                      ({{
                        type == "surgeon_assistant"
                          ? $t("hospital.surgeon-assistant")
                          : $t("hospital.anesthetist-assistant")
                      }})
                    </span>
                  </b>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitEditDoctorAssistants"
          class="m-0"
          :disabled="loadingEditDoctorAssistants"
          block
        >
          <span v-if="!loadingEditDoctorAssistants">
            {{ $t("common.save") }}
          </span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormSelect,
  BLink,
  BFormCheckbox,
  BFormDatepicker,
  BFormTimepicker,
  BCardText,
} from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import permissionChecker from "@/mixins/permissionChecker";
import vSelect from "vue-select";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AuditLogDrawer = () => import("@/components/audit/AuditLogDrawer.vue");
const PatientSurgeryAuditLog = () => import("@/views/accounting/PatientSurgeryAuditLog.vue");
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormSelect,
    BLink,
    StatisticCardHorizontal,
    vSelect,
    AutoComplete,
    Datepicker,
    BFormDatepicker,
    BFormTimepicker,
    BCardText,
    AuditLogDrawer,
    PatientSurgeryAuditLog,
  },
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      tableColumns: [
        {
          key: "actions",
          label: this.$t("common.actions"),
        },
        { key: "title", sortable: true, label: this.$t("common.name") },
        { key: "price", sortable: true, label: this.$t("common.price") },
        {
          key: "total_discount",
          sortable: true,
          label: this.$t("surgery.total_discount"),
        },
        {
          key: "total_price_after_discount",
          sortable: true,
          label: this.$t("surgery.total_price_after_discount"),
        },
        // { key: "type", sortable: true, label: this.$t("common.type") },
        // {
        //   key: "procedure",
        //   sortable: true,
        //   label: this.$t("surgery.procedure"),
        // },

        {
          key: "surgery_doctor",
          sortable: true,
          label: this.$t("surgery.surgery_doctor"),
        },
        {
          key: "doctors_assistants_prices",
          sortable: true,
          label: this.$t("accounting.doctor_assistants"),
        },
        {
          key: "consultancy_doctors",
          sortable: true,
          label: this.$t("surgery.consultancy_doctors"),
        },
        {
          key: "surgery_date_time",
          sortable: true,
          label: this.$t("surgery.surgery_date_time"),
        },
        // {
        //   key: "has_sub_surgery",
        //   sortable: true,
        //   label: this.$t("surgery.has_sub_surgery"),
        // },
        {
          key: "is_sub_surgery",
          sortable: true,
          label: this.$t("surgery.is_sub_surgery"),
        },
        {
          key: "money_collected",
          sortable: true,
          label: this.$t("surgery.is_money_collected"),
        },
      ],
      params: {
        form: {},
        path: "",
      },
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      surgery_set_price_id: "",
      surgeryPrice: {
        price: 0,
        surgery_discount: 0,
        doctors: [
          {
            id: "",
            doctor_discount: 0,
            doctor_price: 0,
            name: "",
            type: "",
          },
        ],
        doctors_consultancies: [
          {
            id: "",
            doctor_price: 0,
            name: "",
          },
        ],
        doctor_assist: [
          {
            id: "",
            type: "",
            doctor_assistant_price: 0,
            name: "",
          },
        ],
      },
      payDoctorData: {},
      payDoctorDataPost: {
        id: "",
        doctors: { doctor_id: "", name: "", isSelected: false },
      },
      surgery_id: null,
      surgeyPrice: 0,
      surgery_date: "",
      surgeryName: "",
      take: 10,
      consultancy_doctors: [],
      updateConsultancy: null,
      doctors: [],
      selectedSurgery: {
        surgery: {
          title: "",
        },
      },
      updateDoctorSurgery: null,
      doctorSurgeryData: [],
      loadingEditDoctorSurgery: false,
      loadingEditDoctorConsultancy: false,
      loadingOpenEditDoctorSurgeryModal: false,
      loadingOpenEditDoctorConsultancyModal: false,
      selectedDoctors: [],
      selectedDoctorAssistants: [],
      loadingOpenEditDoctorAssistantsModal: false,
      loadingEditDoctorAssistants: false,
      doctorAssistants: [],
      DoctorAssistantsModalData: [],
      splitAmount: 0,
    };
  },
  mounted() {
    this.getSurgeryList();
  },
  methods: {
    async openEditDoctorAssistantsModal(item) {
      this.loadingOpenEditDoctorAssistantsModal = true;
      this.DoctorAssistantsModalData = item;

      this.selectedDoctorAssistants = (item.doctor_assist || []).map((doctor) => ({
        id: doctor.id,
        name: doctor.name,
        type: doctor.type,
      }));

      await this.getDoctorAssistants();
      this.loadingOpenEditDoctorAssistantsModal = false;
      this.$bvModal.show(`modal-edit-doctor-assistants`);
    },
    async getDoctorAssistants() {
      try {
        const response = await this.getList("/doctorAssistants");
        this.doctorAssistants = response.data.data;
      } catch (error) {
        console.error("Error fetching doctor assistants:", error);
      }
    },
    formatIQD(value) {
      // format the value to be in IQD currency , you can use ar-IQ for arabic currency
      if (value == null) {
        value = 0;
      }
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "IQD",
      });
    },
    formatDoctorPrices(item) {
      if (!item?.items?.length) return [];
      return item.items.map((doctor) => {
        return {
          id: doctor.id,
          doctor_id: doctor.doctor_id,
          name: doctor.doctor?.name ?? "",
          doctor_price: doctor.doctor_price,
          doctor_discount: doctor.doctor_discount,
          payment_status: doctor.payment_status,
        };
      });
    },
    formatDoctorAssistantsPrices(item) {
      if (!item?.items?.length) return [];
      return item.items.map((doctor) => {
        return {
          id: doctor.id,
          doctor_id: doctor.doctor_assistant_id,
          name: doctor.doctor_assistant?.name ?? "",
          doctor_assistant_price: doctor.doctor_assistant_price,
          payment_status: doctor.payment_status,
        };
      });
    },
    splitAmountBetweenDoctors() {
      if (!this.splitAmount || this.splitAmount <= 0) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: this.$t("surgery.please-enter-valid-amount"),
          },
        });
        return;
      }
      
      if (!this.surgeryPrice.doctors || this.surgeryPrice.doctors.length === 0) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: this.$t("surgery.no-doctors-to-split-amount"),
          },
        });
        return;
      }
      
      // Calculate the amount per doctor (rounded to 2 decimal places)
      const doctorCount = this.surgeryPrice.doctors.length;
      const amountPerDoctor = Math.floor((this.splitAmount / doctorCount) * 100) / 100;
      
      // Update each doctor's price
      this.surgeryPrice.doctors.forEach(doctor => {
        doctor.doctor_price = amountPerDoctor;
      });
      
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title: "Success",
          variant: "success",
          text: this.$t("surgery.amount-split-successfully"),
        },
      });
      
      // Reset the split amount
      this.splitAmount = 0;
    },
    async submitEditDoctorAssistants() {
      console.log("doctorAssistants", this.selectedDoctorAssistants);
      this.loadingEditDoctorAssistants = true;

      this.params.form = {
        surgery_id: this.DoctorAssistantsModalData.surgery_id,
        doctor_assist: this.selectedDoctorAssistants.map((doctor) => ({
          id: doctor.id,
          type: doctor.type,
        })),
        _method: "PUT",
      };

      // Use the id of the current surgery record for the endpoint
      this.params.path = `/patient-surgery/${this.DoctorAssistantsModalData.id}`;

      try {
        await this.$store.dispatch("put", this.params);
        this.loadingEditDoctorAssistants = false;
        this.$bvModal.hide("modal-edit-doctor-assistants");
        this.getSurgeryList();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Doctor assistants updated successfully",
          },
        });
      } catch (error) {
        this.loadingEditDoctorAssistants = false;
        if (error.response && error.response.status === 400) {
          Object.keys(error.response.data).forEach((item) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          });
        }
      }
    },
    showModal(item) {
      this.$bvModal.show("modal-pay-doctor");
      this.payDoctorData = item;
      this.payDoctorDataPost.doctors = (item.doctors || []).map((doctor) => {
        return { doctor_id: doctor.id, name: doctor.name, isSelected: false };
      });
    },
    show(item) {
      this.selectedSurgery = item;
      this.surgery_set_price_id = item.id;
      this.surgeryPrice.price = item.price;
      this.surgeryPrice.surgery_discount = item.surgery_discount;
      this.surgeryPrice.doctors = (item.doctors_prices?.items || []).map((doctor) => {
        return {
          id: doctor.doctor_id,
          doctor_discount: doctor.doctor_discount,
          doctor_price: doctor.doctor_price,
          name: doctor.doctor?.name ?? "",
          type: doctor.doctor?.type,
        };
      });
      this.surgeryPrice.doctor_assist =
        (item.doctors_assistants_prices?.items || []).map((doctor) => {
          return {
            id: doctor.doctor_assistant_id,
            type: doctor.doctor_assistant?.type,
            doctor_assistant_price: doctor.doctor_assistant_price,
            name: doctor.doctor_assistant?.name ?? "",
          };
        });
      this.surgeryPrice.doctors_consultancies =
        (item.doctors_consultancies_prices?.items || []).map((doctor) => {
          return {
            id: doctor.doctor_id,
            doctor_price: doctor.doctor_price,
            name: doctor.doctor?.name ?? "",
          };
        });
      console.log(item);
      console.log(this.surgeryPrice);
      this.$bvModal.show("modal-set-surgery-price");
    },
    formatDate(wantedDate) {
      const date = new Date(wantedDate);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    async submitSetSurgeryPrice() {
      this.loading = true;
      // Calculate total doctor prices
      const totalDoctorPrices = this.surgeryPrice.doctors.reduce(
        (sum, doctor) => {
          return sum + Number(doctor.doctor_price);
        },
        0
      );

      // Validate if total doctor prices exceed surgery price
      if (totalDoctorPrices > this.surgeryPrice.price) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: "Total doctor prices cannot exceed the surgery price",
          },
        });
        this.loading = false;
        return;
      }

      // this.surgeryPrice.doctors = this.surgeryPrice.doctors.map((doctor) => {
      //   return {
      //     id: doctor.id,
      //     doctor_discount: doctor.doctor_discount,
      //     doctor_price: doctor.doctor_price,
      //   };
      // });
      (this.params.form = this.surgeryPrice),
        (this.params.path = `/patient-surgery/prices/${this.surgery_set_price_id}`),
        this.$store
          .dispatch("put", this.params)
          .then((response) => {
            this.loading = false;
            this.$bvModal.hide("modal-set-surgery-price");
            this.getSurgeryList();
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 400) {
              Object.keys(error.response.data).forEach((item) => {
                this.errorForm[item] = error.response.data[item][0];
              });
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    async getSurgeryList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      const patientId = this.$route.params.patientId;
      let url = `/patient-surgery?page=${this.page}&take=${this.take}&sort=-id&include[]=surgery&include[]=doctors&include[]=doctorAssist`;
      
      // Filter by patient_id: first get all patient cards for this patient, then filter surgeries by those card IDs
      if (patientId) {
        try {
          // Fetch patient cards for this patient
          await this.getList(`/patientCard?filter[patient_id]=${patientId}&take=1000&sort=-id`);
          const patientCards = this.all_data && this.all_data.data ? this.all_data.data : [];
          
          if (patientCards.length > 0) {
            // Extract card IDs and filter surgeries by them
            const cardIds = patientCards.map(card => card.id).join(',');
            url += `&filter[patient_card_id]=${cardIds}`;
          } else {
            // No patient cards found, set empty result
            this.data = [];
            this.dataCount = 0;
            this.loading = false;
            return;
          }
        } catch (error) {
          console.error('Error fetching patient cards:', error);
          // Continue without filter if card fetch fails
        }
      }

      if (this.surgeryName) {
        url += `&filter[patientCard.patient.name]=${this.surgeryName}`;
      }
      if (this.surgeyPrice) {
        url += `&filter[price]=${this.surgeyPrice}`;
      }
      if (this.surgery_date) {
        console.log(this.surgery_date);
        url += `&filter[created_at]=${this.formatDate(this.surgery_date)}`;
      }
      if (this.surgery_id) {
        url += `&filter[surgery_id]=${this.surgery_id}`;
      }
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
    payDoctorPrice() {
      const isSelectAll = this.payDoctorDataPost.doctors.find(
        (x) => x.isSelected === false
      );
      if (!isSelectAll) {
        (this.params.form = ""),
          (this.params.path = `/patient-surgery/${this.payDoctorData.id}/payDoctor`),
          this.$store
            .dispatch("put", this.params)
            .then((response) => {
              this.getSurgeryList();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "pay doctor",
                  variant: "success",
                  text: "Doctor has been paid successfully",
                },
              });
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        this.payDoctorDataPost.doctors.forEach((item) => {
          if (item.isSelected === true) {
            const data = { doctor_id: item.doctor_id };
            (this.params.form = data),
              (this.params.path = `/patient-surgery/${this.payDoctorData.id}/payDoctor`),
              this.$store
                .dispatch("put", this.params)
                .then((response) => {
                  this.getSurgeryList();
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "pay doctor",
                      variant: "success",
                      text: "Doctor has been paid successfully",
                    },
                  });
                })
                .catch((error) => {
                  if (error.response.status === 400) {
                    for (let item in error.response.data) {
                      this.$toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                          title: "validation error",
                          variant: "danger",
                          text: error.response.data[item][0],
                        },
                      });
                    }
                  }
                });
          }
        });
      }
    },

    // add consultancy
    async openAddConsultancyModal(item) {
      this.loadingOpenEditDoctorConsultancyModal = true;
      this.updateConsultancy = item;
      this.consultancy_doctors = (item.doctors_consultancies_prices?.items || [])
        .filter((doctor) => doctor.doctor)
        .map((doctor) => ({ ...doctor.doctor }));
      console.log("consultancy_doctors", this.consultancy_doctors);
      await this.getDoctors();
      this.loadingOpenEditDoctorConsultancyModal = false;
      this.$bvModal.show("modal-add-consultancy");
    },
    async getDoctors() {
      await this.getList("doctor?take=100").then((response) => {
        this.doctors = response.data.data.map((doctor) => ({
          id: doctor.id,
          name: doctor.name,
          type: doctor.type,
        }));
      });
    },
    async addConsultancy() {
      this.loadingEditDoctorConsultancy = true;
      const surgeryId = this.updateConsultancy.id;
      const payload = {
        surgery_id: this.updateConsultancy.surgery_id,
        _method: "PUT",
        doctors_consultancies: this.consultancy_doctors.map(
          (doctor) => doctor.id
        ),
      };
      this.params.form = payload;
      this.params.path = `/patient-surgery/${surgeryId}`;
      try {
        // Call the API using a POST request (with _method override to PUT)
        await this.$store.dispatch("create", this.params);
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Consultancy updated successfully",
          },
        });
        // Refresh the list if needed
        this.getSurgeryList();
        this.loadingEditDoctorConsultancy = false;
        // Hide the modal after success
        this.$bvModal.hide("modal-add-consultancy");
      } catch (error) {
        this.loadingEditDoctorConsultancy = false;
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Error",
            variant: "danger",
            text: error.response.data || "Failed to update consultancy",
          },
        });
      }
    },

    // edit doctor surgery
    async openEditDoctorSurgeryModal(item) {
      this.loadingOpenEditDoctorSurgeryModal = true;

      // Extract doctor prices data
      const extractDoctorData = (doctor) => ({
        id: doctor.doctor_id,
        doctor_discount: doctor.doctor_discount,
        doctor_price: doctor.doctor_price,
      });

      // Extract consultancy data
      const extractConsultancyData = (doctor) => ({
        id: doctor.doctor_id,
        doctor_price: doctor.doctor_price,
      });

      // Initialize surgery price data
      this.surgeryPrice = {
        price: item.price,
        surgery_discount: item.surgery_discount,
        doctors: (item.doctors_prices?.items || []).map(extractDoctorData),
        doctors_consultancies: (item.doctors_consultancies_prices?.items || []).map(
          extractConsultancyData
        ),
      };

      this.updateDoctorSurgery = item;

      this.doctorSurgeryData = (item.doctors_prices?.items || []).map((doctor) => ({
        ...extractDoctorData(doctor),
        name: doctor.doctor?.name ?? "",
      }));
      this.selectedDoctors = (item.doctors_prices?.items || []).map((doctor) => ({
        id: doctor.doctor_id,
        name: doctor.doctor?.name ?? "",
        type: doctor.doctor?.type,
      }));

      console.log("doctorSurgeryData", this.doctorSurgeryData);
      await this.getDoctors();
      this.loadingOpenEditDoctorSurgeryModal = false;
      this.$bvModal.show(`modal-edit-doctor-surgery`);
    },

    async submitEditDoctorSurgery() {
      console.log("surgeryPrice", this.doctorSurgeryData);
      this.loadingEditDoctorSurgery = true;

      this.params.form = {
        doctors: this.selectedDoctors,
        _method: "PUT",
        surgery_id: this.updateDoctorSurgery.surgery_id,
      };

      // Use the id of the current surgery record for the endpoint
      this.params.path = `/patient-surgery/${this.updateDoctorSurgery.id}`;

      try {
        await this.$store.dispatch("put", this.params);
        this.loadingEditDoctorSurgery = false;
        this.$bvModal.hide("modal-edit-doctor-surgery");
        this.getSurgeryList();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Doctor prices updated successfully",
          },
        });
      } catch (error) {
        this.loadingEditDoctorSurgery = false;
        if (error.response && error.response.status === 400) {
          Object.keys(error.response.data).forEach((item) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          });
        }
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.doctor-prices {
  padding: 0.5rem;
}

.doctor-price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.doctor-price-item:last-child {
  border-bottom: none;
}

.doctor-name {
  font-weight: 500;
  color: #2c3e50;
}

.price-details {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.price {
  font-weight: 600;
  color: #27ae60;
}

.discount {
  font-weight: 600;
  color: #27ae60;
}

.status-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
}

.status-paid {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.status-pending {
  background-color: #fff3e0;
  color: #f57c00;
}

.total-price {
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-radius: 4px;
  text-align: right;
  font-size: 1.1rem;
  margin-top: 0.5rem;
}

.price-cell-alt,
.discount-cell-alt,
.final-price-cell-alt {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
}

.price-icon,
.discount-icon,
.final-price-icon {
  font-size: 1.5rem;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.price-cell-alt {
  .price-icon {
    background-color: #e8f5e9;
    color: #2e7d32;
  }
  .price-title {
    color: #666;
    font-size: 0.9rem;
  }
  .price-amount {
    color: #2e7d32;
    font-weight: 600;
    font-size: 1.1rem;
  }
}

.discount-cell-alt {
  .discount-icon {
    background-color: #fff3e0;
    color: #f57c00;
  }
  .discount-title {
    color: #666;
    font-size: 0.9rem;
  }
  .discount-amount {
    color: #f57c00;
    font-weight: 600;
    font-size: 1.1rem;
  }
}

.final-price-cell-alt {
  .final-price-icon {
    background-color: #e3f2fd;
    color: #1976d2;
  }
  .final-price-title {
    color: #666;
    font-size: 0.9rem;
  }
  .final-price-amount {
    color: #1976d2;
    font-weight: 600;
    font-size: 1.1rem;
  }
}

/* Custom styling for the horizontal divider */
.divider {
  border: none;
  height: 2px;
  background-color: #dee2e6; /* a light gray, adjust as needed */
  margin: 1.5rem 0; /* vertical spacing */
}

/* Add a light blue background to the consultancy block */
.consultancy-bg {
  background-color: #f0f8ff; /* AliceBlue, adjust as needed */
  /* Optionally, you can add some padding or border color changes */
}

/* Ensure primary text is properly styled (if not already provided by Bootstrap) */
.text-primary {
  color: #007bff;
}

.text-green {
  color: #2e7d32;
}

/* Styling for the doctor's section with a light peach background */
.doctor-bg {
  background-color: #fff4e6; /* Light peach color, adjust as needed */
  /* Optional: add a subtle accent border color */
  border-color: #f0c987;
}

.surgery-price-bg {
  background-color: #e0f7fa; /* a light cyan color, adjust as needed */
}

.doctor-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  margin: 5px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 200px;
  text-align: center;
}

.role-selection {
  margin-top: 10px;
}

.role-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.role-checkbox >>> .custom-control-label {
  font-size: 14px;
  color: #333;
}

.role-checkbox
  >>> .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.role-checkbox >>> .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
